import React, { Component } from "react";
import { Switch, Route, withRouter,Redirect } from "react-router-dom";
import asyncComponent from "util/asyncComponent";
import CustomerBookingContainer from "./CustomerBookingContainer";
import BookAppointmentContainer from "./BookAppointmentContainer";
import BusinessPageContainer from "./BusinessPageContainer";
import Logout from "./Logout";
import CustomerProfile from "./CustomerProfile";
import Appointments from "./Appointments";
import UserActivation from "../components/UserActivation";
const authUser=localStorage.getItem("token");
const RestrictedRoute = ({ component: Component, authUser, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("token") ? (
        <Component {...props} user={authUser} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
          }}
        />
      )
    }
  />
);
class CustomerFlow extends Component {
  render() {
    return (
      <React.Fragment>
        <Switch>
         <RestrictedRoute
               path={"/profile"}
           authUser
           component={CustomerProfile}
        /> 
        <RestrictedRoute
        path={"/appointments"}
    authUser
    component={Appointments}
 /> 
          <Route exact path={`${this.props.match.url}`} component={CustomerBookingContainer} />
          <Route path='/logout' component={Logout} />
          <Route path='/user-activation' component={UserActivation} />
         
          <Route
            path={`${this.props.match.url}:id/book-appointment`}
            component={BookAppointmentContainer}
          />
          <Route path={`${this.props.match.url}:id`} component={BusinessPageContainer} />
          
        </Switch>
      </React.Fragment>
    );
  }
}

export default withRouter(CustomerFlow);



// WEBPACK FOOTER //
// ./containers/CustomerFlow.js